import "./AboutUsStyle.css"
import React from 'react'

export default function AboutUs() {
  return (
    <>
    <div className="about-center">
        <h1>Our history</h1>
        <p>Tripidea is the Website developed and manages by Shubham Sharma. This web site is developed for easyy planning the tips and getting the idea of the popular locations and exploring the Citys easily</p>
        <h1>our Mission</h1>
        <p>Our mission is to make make your plan an excelent and memorable trip and make your vecation enjoyable and make a happy memories with your family friends and also with the loved one.</p>
        <h1>our Vision</h1>
        <p>Our vision is to make this website a popular Website and add more Cities and the popular places with the honest peoples reviews.</p>
        </div> 
    </>
  )
}
